import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DatePicker, { registerLocale } from "react-datepicker";
import { zhTW, zhCN, enUS } from 'date-fns/locale';

import "react-datepicker/dist/react-datepicker.css";

const Calendar = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;
	const {fieldname, required} = form_component;

	const fv = useSelector(state => state.fv);

	const [date, setDate] = useState();
	const locales = { zhTW, zhCN, enUS };
	Object.entries(locales).forEach(([key, value]) => registerLocale(key, value));

	useEffect(() => { // to be updated after render
		if (fv && required) {
			fv.addField(fieldname, {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			});
		}
	}, [fv]);

	const onChange = (value) => {
		console.log(`value`, value);
		const formattedDate = value ? value.toLocaleDateString('en-CA') : '';  // en-CA gives yyyy-MM-dd format
		setDate(value);
	};

	return (
		<DatePicker
			className="form-control form-control-sm"
			showIcon
			dateFormat="yyyy-MM-dd"
			showMonthDropdown
			showYearDropdown
			selected={date}
			onChange={(date) => {
				onChange(date)
			}}
			name={fieldname}
			locale={i18n.language.replace('-', '')}
			xplaceholderText={t('請選擇日期')}
		/>
	);
}

export default Calendar;